export function currencyFormatter(currency, homeCurrency) {
    if (currency === 'UNKNOWN')
        currency = undefined;
    currency = currency || 'USD';
    let locale = 'en-US';
    if (homeCurrency) {
        // If we have a home currency, try an determining the locale from it
        switch (homeCurrency) {
            case 'GBP':
                locale = 'en-GB';
                break;
            case 'EUR':
                locale = 'de-DE';
                break;
            case 'JPY':
                locale = 'ja-JP';
                break;
            case 'AUD':
                locale = 'en-AU';
                break;
            case 'CAD':
                locale = 'en-CA';
                break;
            case 'NZD':
                locale = 'en-NZ';
                break;
            case 'INR':
                locale = 'en-IN';
                break;
            case 'SGD':
                locale = 'en-SG';
                break;
            case 'ZAR':
                locale = 'en-ZA';
                break;
            case 'HKD':
                locale = 'zh-HK';
                break;
            // Add more cases as needed for other currencies
            default:
                locale = 'en-US'; // Fallback to US English
        }
    }
    let formatter;
    try {
        formatter = new Intl.NumberFormat(locale, { style: 'currency', currency });
    }
    catch (_a) {
        // Unsynced or invalid ISO code (e.g. 'NOT_SYNCED' before first sync) - fall back rather than crash the UI
        formatter = new Intl.NumberFormat(locale, { style: 'currency', currency: 'USD' });
    }
    const format = (amount) => {
        if (amount === undefined || amount === null) {
            amount = 0;
        }
        const asDecimal = Number(amount.toFixed(2));
        const result = formatter.format(asDecimal);
        if (result === 'NaN') {
            return `Unknown`;
        }
        return result;
    };
    return format;
}
/** The symbol for an ISO currency code, e.g. NZD -> $, GBP -> £. Falls back to the code itself */
export function currencySymbol(currency) {
    if (!currency || currency === 'UNKNOWN')
        return '$';
    try {
        const part = new Intl.NumberFormat('en-US', { style: 'currency', currency, currencyDisplay: 'narrowSymbol' })
            .formatToParts(0)
            .find(p => p.type === 'currency');
        return (part === null || part === void 0 ? void 0 : part.value) || currency;
    }
    catch (_a) {
        return currency;
    }
}
//# sourceMappingURL=currencyUtils.js.map